<template>
  <div>
    <PageAllow controller="SummaryMonthlyStatement" action="index" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1 pe-2">
              <SearcherDatetimeRange
                type="datetime"
                v-model="datetimeRage"
                :label="$t('summaryDailyStatement.created')"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />

            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherShop v-model="shopSelected" :shopId="shopId"/>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherStocks v-model="stocksSelected" :stockId="stockId"/>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="summaryDailyStatement"
          :options.sync="options"
          :loading="loading"
          disable-pagination
          hide-default-footer
          multi-sort
          class="elevation-1 px-4 pt-1 sticky-first-col"
          fixed-header
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:item.shop_code="{ item }">
            {{ item.shop_name }} / {{ item.shop_code }}
          </template>
          <template v-slot:item.stock_name="{ item }">
            {{ item.stock_name ? item.stock_name : $t("summaryMonthlyStatementDetail.refund") }}
          </template>
          <template v-slot:item.statement_date="{ item }">
            {{ item.statement_date | formatTime }}
          </template>
          <template v-slot:item.order_total_fee="{ item }">
            {{ $t("Global.money") }}{{ item.order_total_fee | formatMoney }}
          </template>
          <template v-slot:item.stock_out_total_fee="{ item }">
            {{ $t("Global.money") }}{{ item.stock_out_total_fee | formatMoney }}
          </template>
          <template v-slot:item.examine_total_fee="{ item }">
            {{ $t("Global.money") }}{{ item.examine_total_fee | formatMoney }}
          </template>
          <template v-slot:item.finance_bill_total_fee="{ item }">
            {{ $t("Global.money") }}{{ item.finance_bill_total_fee | formatMoney }}
          </template>
          <template v-slot:item.return_order_total_fee="{ item }">
            {{ $t("Global.money") }}{{ item.return_order_total_fee | formatMoney }}
          </template>
          <template v-slot:item.return_finance_bill_total_fee="{ item }">
            {{ $t("Global.money") }}{{ item.return_finance_bill_total_fee | formatMoney }}
          </template>
          <template v-slot:item.finally_sale_total_fee="{ item }">
            {{ $t("Global.money") }}{{ item.finally_sale_total_fee | formatMoney }}
          </template>
          <template v-slot:item.finally_return_total_fee="{ item }">
            {{ $t("Global.money") }}{{ item.finally_return_total_fee | formatMoney }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip
              top
              v-if="$permission.permissionAllow('SummaryMonthlyStatement', 'dailyStatementView')"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="info"
                  class="px-2 me-2 mb-1"
                  @click.stop="materialDetailDialog = true;currentItem = item"
                >
                  <v-icon x-small class="pe-1">fa-align-left</v-icon>
                  {{ $t("summaryDailyStatement.actions.materialDetail") }}
                </v-btn>
              </template>
              <span>{{ $t("summaryDailyStatement.actions.materialDetail") }}</span>
            </v-tooltip>
            <v-tooltip
              top
              v-if="$permission.permissionAllow('SummaryMonthlyStatement', 'dailyStatementBillView')"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="info"
                  class="px-2 me-2 mb-1"
                  @click.stop="billDetailDialog = true;currentItem = item"
                >
                  <v-icon x-small class="pe-1">fa-align-left</v-icon>
                  {{ $t("summaryDailyStatement.actions.billDetail") }}
                </v-btn>
              </template>
              <span>{{ $t("summaryDailyStatement.actions.billDetail") }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </div>
    </v-sheet>
    <MaterialDetailDialog
      v-model="materialDetailDialog"
      :currentItem="currentItem"
    />
    <BillDetailDialog
      v-model="billDetailDialog"
      :currentItem="currentItem"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import consts from "@/consts";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SummaryMonthlyStatement from "@/api/summary_monthly_statement";
import SearcherDatetimeRange from "@/components/plugins/SearcherDatetimeRange";
import SearcherShop from "./plugins/SearcherShop"
import SearcherStocks from "./plugins/SearcherStocks";
import MaterialDetailDialog from "./plugins/MaterialDetailDialog";
import BillDetailDialog from "./plugins/BillDetailDialog";

const defaultOptions = {
  summary_month: new Date().toISOString().substr(0, 7),
  shop_id: "",
  stock_ids: [],
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRange,
    SearcherShop,
    SearcherStocks,
    MaterialDetailDialog,
    BillDetailDialog,
  },

  data: () => ({
    options: JSON.parse(
      sessionStorage.getItem("summary-daily-statement-options")
        ? sessionStorage.getItem("summary-daily-statement-options")
        : JSON.stringify(defaultOptions)
    ),
    datetimeRage: [
      new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
          .toISOString()
          .substr(0, 10) + " 00:00:00",
      new Date().toISOString().substr(0, 10) + " 23:59:59",
    ],
    summaryDailyStatement: [],
    shopSelected: null,
    stocksSelected: [],
    shopId: null,
    stockId: null,
    currentItem: null,
    materialDetailDialog: false,
    billDetailDialog: false,
  }),

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.statementManagement"),
        disabled: false,
        href: "/summary-daily-statement",
      },
      {
        text: i18n.t("Nav.summaryDailyStatement"),
        disabled: true,
        href: "/summary-daily-statement",
      },
    ],

    headers:() => [
      {
        text: i18n.t("summaryDailyStatement.Fields.shop", [consts.shopName()]),
        align: "center",
        class: "text-no-wrap",
        sortable: false,
        value: "shop_code",
      },
      {
        text: i18n.t("summaryDailyStatement.Fields.stock"),
        align: "center",
        class: "text-no-wrap",
        sortable: false,
        value: "stock_name",
      },
      {
        text: i18n.t("summaryDailyStatement.Fields.statement_date"),
        align: "center",
        class: "text-no-wrap",
        sortable: false,
        value: "statement_date",
      },
      {
        text: i18n.t("summaryDailyStatement.Fields.order_num"),
        align: "end",
        sortable: false,
        class: "text-no-wrap",
        value: "order_num",
      },
      {
        text: i18n.t("summaryDailyStatement.Fields.order_total_fee"),
        align: "end",
        sortable: false,
        class: "text-no-wrap",
        value: "order_total_fee",
      },
      {
        text: i18n.t("summaryDailyStatement.Fields.stock_out_num"),
        align: "end",
        sortable: false,
        class: "text-no-wrap",
        value: "stock_out_num",
      },
      {
        text: i18n.t("summaryDailyStatement.Fields.stock_out_total_fee"),
        align: "end",
        sortable: false,
        class: "text-no-wrap",
        value: "stock_out_total_fee",
      },
      {
        text: i18n.t("summaryDailyStatement.Fields.examine_num"),
        align: "end",
        sortable: false,
        class: "text-no-wrap",
        value: "examine_num",
      },
      {
        text: i18n.t("summaryDailyStatement.Fields.examine_total_fee"),
        align: "end",
        sortable: false,
        class: "text-no-wrap",
        value: "examine_total_fee",
      },
      {
        text: i18n.t("summaryDailyStatement.Fields.return_order_num"),
        align: "end",
        sortable: false,
        class: "text-no-wrap",
        value: "return_order_num",
      },
      {
        text: i18n.t("summaryDailyStatement.Fields.return_order_total_fee"),
        align: "end",
        sortable: false,
        class: "text-no-wrap",
        value: "return_order_total_fee",
      },
      {
        text: i18n.t("summaryDailyStatement.Fields.finance_bill_num"),
        align: "end",
        sortable: false,
        class: "text-no-wrap",
        value: "finance_bill_num",
      },
      {
        text: i18n.t("summaryDailyStatement.Fields.finance_bill_total_fee"),
        align: "end",
        sortable: false,
        class: "text-no-wrap",
        value: "finance_bill_total_fee",
      },
      {
        text: i18n.t("summaryDailyStatement.Fields.return_finance_bill_num"),
        align: "end",
        sortable: false,
        class: "text-no-wrap",
        value: "return_finance_bill_num",
      },
      {
        text: i18n.t("summaryDailyStatement.Fields.return_finance_bill_total_fee"),
        align: "end",
        sortable: false,
        class: "text-no-wrap",
        value: "return_finance_bill_total_fee",
      },
      {
        text: i18n.t("summaryDailyStatement.Fields.finally_sale_num"),
        align: "end",
        sortable: false,
        class: "text-no-wrap",
        value: "finally_sale_num",
      },
      {
        text: i18n.t("summaryDailyStatement.Fields.finally_sale_total_fee"),
        align: "end",
        sortable: false,
        class: "text-no-wrap",
        value: "finally_sale_total_fee",
      },
      {
        text: i18n.t("summaryDailyStatement.Fields.finally_return_num"),
        align: "end",
        sortable: false,
        class: "text-no-wrap",
        value: "finally_return_num",
      },
      {
        text: i18n.t("summaryDailyStatement.Fields.finally_return_total_fee"),
        align: "end",
        sortable: false,
        class: "text-no-wrap",
        value: "finally_return_total_fee",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "center",
        class: "text-no-wrap",
        sortable: false,
        value: "actions",
      }
    ],
    ...mapState(["loading", "settings"]),
  },

  mounted() {
    this.$commonUtils.loadOptions("summary-daily-statement", ["shopSelected", "stocksSelected", "searchers"]).then(
        function (data) {
          if (data.options) {
            this.options = data.options
            if (
                typeof this.options.summary_time_from != "undefined" &&
                typeof this.options.summary_time_to != "undefined"
            )
              this.datetimeRage = [
                this.options.summary_time_from,
                this.options.summary_time_to,
              ];
          } else this.resetSearch();
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "shopSelected":
                this.shopSelected = selected.value;
                break;
              case "stocksSelected":
                this.stocksSelected = selected.value;
                break;
              case "searchers":
                // 月账单记录的检索条件
                this.shopId = selected.value.shop_id;
                this.stockId = selected.value.stock_id;
                sessionStorage.removeItem("summary-daily-statement-searchers")
                break;
            }
          });
        }.bind(this)
    );
  },

  methods: {
    onSearch() {
      // 搜索
      this.options = Object.assign({}, this.options);
    },
    resetSearch() {
      this.datetimeRage = [
        new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
            .toISOString()
            .substr(0, 10) + " 00:00:00",
        new Date().toISOString().substr(0, 10) + " 23:59:59",
      ];
      this.shopSelected = null;
      this.stocksSelected = [];
      this.summaryDailyStatement = [];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getSummaryDailyStatementFromAPI() {
      if (!this.options.shop_id) {
        this.summaryDailyStatement = [];
        return
      }
      SummaryMonthlyStatement.dailyStatement(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.summaryDailyStatement = response.data.summary_daily_statement.map((detail) => {
              detail.statement_date = this.$datetimeUtils.formatTime(detail.statement_date)
              return detail;
            });
          }
        }.bind(this)
      );
    },
  },

  watch: {
    options: {
      deep: true,
      handler() {
        this.getSummaryDailyStatementFromAPI();
        sessionStorage.setItem(
            "summary-daily-statement-options",
            JSON.stringify(this.options)
        );
      },
    },
    datetimeRage: {
      handler() {
        if (this.datetimeRage[0] == null || this.datetimeRage[0] == "") {
          this.options.summary_time_from =
              new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
                  .toISOString()
                  .substr(0, 10) + " 00:00:00";
        } else {
          this.options.summary_time_from = this.datetimeRage[0];
        }

        if (this.datetimeRage[1] == null || this.datetimeRage[1] == "") {
          this.options.summary_time_to =
              new Date().toISOString().substr(0, 10) + " 23:59:59";
        } else {
          this.options.summary_time_to = this.datetimeRage[1];
        }
      },
    },
    shopSelected: {
      handler() {
        this.options.shop_id = this.shopSelected ? this.shopSelected.id : "";
        sessionStorage.setItem(
            "summary-daily-statement-shopSelected",
            JSON.stringify(this.shopSelected)
        );
      },
    },
    stocksSelected: {
      handler() {
        this.options.stock_ids = this.stocksSelected
          ? this.stocksSelected.map((e) => {
            return e.id;
          })
          : null;
        sessionStorage.setItem(
            "summary-daily-statement-stocksSelected",
            JSON.stringify(this.stocksSelected)
        );
      },
    },
  },
};
</script>

<style>
</style>